/**
 * Strip internal container paths before displaying to the user.
 * - /home/appuser/.claude/projects/{key}/{sessionId}/... → /...
 * - /storage/ai-assistant/{uuid}/... → /...
 * - /var/www/public/... → /...
 */
export function cleanPath(text: string): string {
  if (!text) return text;
  text = text.replace(/\/home\/appuser\/\.claude\/projects\/[^/\s]+\/[^/\s]+\//g, '/');
  text = text.replace(/\/storage\/ai-assistant\/[0-9a-f-]{36}\//gi, '/');
  text = text.replace(/\/var\/www\/public\//g, '/');
  return text;
}
